import styled from 'styled-components'
import { PRODUCT_PAGE } from '../../constants/constants'

const QUANTITY_WIDTH_IN_PERCENT = 13

export const ArticlesList = styled.div<{
  applicationMode: string
  isAddToCartPrompt: boolean
  isExpanded: boolean
}>`
  width: 100%;
  margin: ${(props) => (props.applicationMode === PRODUCT_PAGE || !props.isAddToCartPrompt ? '0' : '30px 0 25px')};

  @media (min-width: 1200px) {
    ${(props) => props.applicationMode !== PRODUCT_PAGE && props.isAddToCartPrompt && 'margin-bottom: 30px;'};
  }

  .total-and-articles {
    max-height: ${(props) => (props.isAddToCartPrompt || props.isExpanded ? '100vh' : '0')};
    overflow: hidden;
    transition: max-height 0.2s ease-in-out;
  }

  .total,
  li {
    font-size: 16px;
    padding: 4px 3px;
  }

  .total {
    display: inline-block;
    font-weight: 500;
    text-decoration: underline;
    padding-bottom: 12px;
  }

  ul {
    max-height: 40vh;
    overflow: auto;

    @media (min-width: 1200px) {
      max-height: ${(props) => (props.isAddToCartPrompt ? '40vh' : '30vh')};
    }
  }

  li {
    display: flex;

    &:nth-child(2n) {
      background-color: ${(props) => props.theme.palette.background.main};
    }

    .quantity {
      width: ${QUANTITY_WIDTH_IN_PERCENT}%;
    }

    .title-merged {
      width: ${100 - QUANTITY_WIDTH_IN_PERCENT}%;
    }
  }
`
